// src/firebase/config.js
// ==========================================
// SETUP INSTRUCTIONS:
// 1. Go to https://console.firebase.google.com/
// 2. Create a new project named "hyperdigitech-quiz"
// 3. Enable Firestore Database (in test mode initially)
// 4. Go to Project Settings > General > Your Apps > Add App (Web)
// 5. Copy your config values below
// 6. In Firestore, create collections: "submissions"
// 7. For admin auth: Enable Authentication > Email/Password
//    Create admin user: admin@hyperdigitech.com (set your password)
// ==========================================

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
 apiKey: "AIzaSyCJYdj_n-Dyzgng7UmB4HZSuZ3hr6Vb13E",
  authDomain: "examhyperdigitech.firebaseapp.com",
  projectId: "examhyperdigitech",
  storageBucket: "examhyperdigitech.firebasestorage.app",
  messagingSenderId: "1065858485071",
  appId: "1:1065858485071:web:a839496578c06623cc533a",
  measurementId: "G-7NYV3LF2GL"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
